var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51999 10.1927V8.22023C5.51999 4.64143 8.42119 1.74023 12 1.74023C15.5788 1.74023 18.48 4.64143 18.48 8.22023V10.1927C19.5502 10.2726 20.2471 10.4744 20.7565 10.9838C21.6 11.8273 21.6 13.1849 21.6 15.9002C21.6 18.6155 21.6 19.9732 20.7565 20.8167C19.9129 21.6602 18.5553 21.6602 15.84 21.6602H8.15999C5.4447 21.6602 4.08706 21.6602 3.24353 20.8167C2.39999 19.9732 2.39999 18.6155 2.39999 15.9002C2.39999 13.1849 2.39999 11.8273 3.24353 10.9838C3.75293 10.4744 4.44983 10.2726 5.51999 10.1927ZM6.95999 8.22023C6.95999 5.43672 9.21648 3.18023 12 3.18023C14.7835 3.18023 17.04 5.43672 17.04 8.22023V10.1437C16.6723 10.1402 16.2734 10.1402 15.84 10.1402H8.15999C7.72654 10.1402 7.32768 10.1402 6.95999 10.1437V8.22023ZM13.92 15.9002C13.92 16.9606 13.0604 17.8202 12 17.8202C10.9396 17.8202 10.08 16.9606 10.08 15.9002C10.08 14.8398 10.9396 13.9802 12 13.9802C13.0604 13.9802 13.92 14.8398 13.92 15.9002Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lock.2cac989b.svg";
export { ForwardRef as ReactComponent };